import React from "react";
import "./PopularLocality.css";
import { City_Data } from "../../utility/data/Data";
const PopularLocality = () => {
  return (
    <div className="localitiesWrapper flex column">
      <p>
        Popular localities in and around <span className="localityCity">Bhubaneswar</span>
      </p>
      <div className="localitiesContainer grid">
        {City_Data.map((data) => {
          return (
            <div className="localities flex cursorPointer" key={data.id}>
              <div className="locality flex column">
                <h5>{data.locality}</h5>
                <p>{data.count}</p>
              </div>
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#1C1C1C"
                  width="15"
                  height="15"
                  viewBox="0 0 20 20"
                  aria-labelledby="icon-svg-title- icon-svg-desc-"
                  role="img"
                  className="sc-rbbb40-0 jKmKoK"
                >
                  <title>chevron-right</title>
                  <path d="M6.98 15.94c-0.3-0.28-0.3-0.76 0-1.060l4.46-4.46-4.46-4.48c-0.3-0.28-0.3-0.76 0-1.060s0.76-0.28 1.060 0l5 5c0.28 0.3 0.28 0.78 0 1.060l-5 5c-0.3 0.3-0.78 0.3-1.060 0z"></path>
                </svg>
              </div>
            </div>
          );
        })}
        <div className="localities flex cursorPointer">
          <div className="locality flex column seeMore">see more</div>
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#1C1C1C"
              width="30"
              height="30"
              viewBox="0 0 20 20"
              aria-labelledby="icon-svg-title- icon-svg-desc-"
              role="img"
              className="sc-rbbb40-0 iwHbVQ seeMoreIcon"
            >
              <title>chevron-down</title>
              <path d="M4.48 7.38c0.28-0.28 0.76-0.28 1.060 0l4.46 4.48 4.48-4.48c0.28-0.28 0.76-0.28 1.060 0s0.28 0.78 0 1.060l-5 5c-0.3 0.3-0.78 0.3-1.060 0l-5-5c-0.3-0.28-0.3-0.76 0-1.060z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularLocality;
